/* SushiSushi Masterclass Phase 3 rev3 (2026-06-28). Masterclass blog only.
   1) Add-to-Cart for every .mc-atc form via the theme's window.handleAddToCart;
      native /cart/add submit is the no-JS fallback.
   2) In-body product ROWS (bigger image, short description), DISTRIBUTED
      through the article body:
      - future .mc-inline-product[data-handle] markers render where placed;
      - legacy .mc-product-grid is dissolved and its products are spread as
        rows at intervals down the article.
   Buttons are outline only (View + Add to Cart). */
(function () {
  'use strict';

  function init() {
  var root = document.querySelector('.mc-article');
  if (!root) return;
  var content = root.querySelector('.article-content');

  function money(cents) {
    try {
      var f = (window.KROWN && KROWN.settings && KROWN.settings.shop_money_format) || '';
      if (f && /\{\{\s*amount\s*\}\}/.test(f)) {
        var v = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return f.replace(/\{\{\s*amount\s*\}\}/, v);
      }
    } catch (e) {}
    return '£' + (cents / 100).toFixed(2);
  }

  function formBody(form) {
    var id = form.querySelector('[name="id"]');
    var q = form.querySelector('[name="quantity"]');
    return 'id=' + encodeURIComponent(id ? id.value : '') +
           '&quantity=' + encodeURIComponent(q && q.value ? q.value : '1');
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('form[data-mc-atc]');
    if (!form || !root.contains(form)) return;
    if (typeof window.handleAddToCart !== 'function') return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) { btn.classList.add('working'); btn.setAttribute('aria-busy', 'true'); }
    window.handleAddToCart(
      formBody(form), 1,
      { 'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest' },
      function () {
        if (!btn) return;
        btn.classList.remove('working');
        btn.removeAttribute('aria-busy');
        var label = btn.textContent;
        btn.textContent = 'Added';
        btn.classList.add('is-added');
        setTimeout(function () { btn.textContent = label; btn.classList.remove('is-added'); }, 1600);
      }
    );
  });

  function handleFromUrl(url) {
    if (!url) return null;
    var m = url.match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  function firstVariant(d) {
    if (!d || !d.variants || !d.variants.length) return null;
    for (var i = 0; i < d.variants.length; i++) {
      if (d.variants[i].available) return d.variants[i];
    }
    return d.variants[0];
  }

  // Render a product ROW (image left; name, description, price, View + Add to Cart).
  function render(el, d, title, blurb) {
    var v = firstVariant(d);
    var img = (d.featured_image || (d.images && d.images[0]) || '');
    if (img && img.indexOf('//') === 0) img = 'https:' + img;
    var name = (title && title.trim()) || d.title;
    var price = money(v ? v.price : d.price);
    var url = '/products/' + d.handle;
    var ok = !!(v && v.available);
    var h = '';
    if (img) {
      h += '<a class="mc-inline-product__img" href="' + url + '" tabindex="-1" aria-hidden="true">' +
           '<img src="' + img.replace(/(\.[a-z]+)(\?|$)/i, '_320x$1$2') + '" alt="" loading="lazy"></a>';
    }
    h += '<div class="mc-inline-product__body">';
    h += '<a class="mc-inline-product__name" href="' + url + '">' + name + '</a>';
    if (blurb && blurb.trim()) h += '<p class="mc-inline-product__desc">' + blurb + '</p>';
    h += '<span class="mc-inline-product__price">' + price + '</span>';
    h += '</div>';
    h += '<div class="mc-inline-product__actions">';
    h += '<a class="mc-mini-btn" href="' + url + '">View</a>';
    if (ok) {
      h += '<form class="mc-atc" data-mc-atc method="post" action="/cart/add">' +
           '<input type="hidden" name="id" value="' + v.id + '">' +
           '<input type="hidden" name="quantity" value="1">' +
           '<button type="submit" class="mc-mini-btn mc-mini-btn--solid">Add to Cart</button></form>';
    } else {
      h += '<span class="mc-mini-btn mc-mini-btn--muted" aria-disabled="true">Sold out</span>';
    }
    h += '</div>';
    el.innerHTML = h;
    el.classList.add('is-mc-enhanced');
    squareImage(el);
  }

  // Size the square image to match the row's content height (touches top/bottom padding).
  function squareImage(el) {
    var imgWrap = el.querySelector('.mc-inline-product__img');
    var body = el.querySelector('.mc-inline-product__body');
    if (!imgWrap || !body) return;
    var apply = function () {
      if (window.innerWidth <= 600) { imgWrap.style.width = ''; imgWrap.style.height = ''; return; }
      var hgt = body.offsetHeight;
      if (hgt > 0) { imgWrap.style.width = hgt + 'px'; imgWrap.style.height = hgt + 'px'; }
    };
    requestAnimationFrame(apply);
    if (document.fonts && document.fonts.ready) { document.fonts.ready.then(apply); }
    if (window.ResizeObserver) { new ResizeObserver(apply).observe(body); }
    window.addEventListener('resize', apply);
  }

  function getProduct(handle) {
    return fetch('/products/' + handle + '.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); });
  }

  function fill(el, handle, title, blurb) {
    getProduct(handle)
      .then(function (d) { render(el, d, title, blurb); })
      .catch(function () { el.style.display = 'none'; });
  }

  // (a) Future markers — render where the author placed them.
  if (content) {
    content.querySelectorAll('.mc-inline-product[data-handle]').forEach(function (el) {
      if (el.dataset.mcDone) return;
      el.dataset.mcDone = '1';
      fill(el, el.dataset.handle, el.dataset.title, el.dataset.blurb);
    });
  }

  // (b) Legacy mc-product-grid -> dissolve and DISTRIBUTE its products as rows.
  if (content) {
    content.querySelectorAll('.mc-product-grid').forEach(function (grid) {
      if (grid.dataset.mcDone) return;
      grid.dataset.mcDone = '1';

      // Collect the products (handle, title, description) from the grid's cards.
      var items = [];
      grid.querySelectorAll('.mc-product').forEach(function (card) {
        var link = card.querySelector('a[href*="/products/"]');
        var handle = handleFromUrl(link && link.getAttribute('href'));
        if (!handle) return;
        var t = card.querySelector('h3, h4');
        var p = card.querySelector('p');
        items.push({ handle: handle, title: t ? t.textContent : '', blurb: p ? p.innerHTML : '' });
      });
      if (!items.length) return;

      // Strip the "Popular Products" wrapper (heading + one-line framing + a bounding rule).
      var frame = grid.previousElementSibling;
      var removedWrapper = false;
      if (frame && frame.tagName === 'P') {
        var h2 = frame.previousElementSibling;
        if (h2 && h2.tagName === 'H2' && /popular/i.test(h2.textContent)) {
          frame.remove(); h2.remove(); removedWrapper = true;
        }
      }
      var beforeHr = grid.previousElementSibling;
      var afterHr = grid.nextElementSibling;
      grid.remove();
      if (removedWrapper && beforeHr && beforeHr.tagName === 'HR' && afterHr && afterHr.tagName === 'HR') {
        afterHr.remove();
      }

      // Distribute across the section rules that remain.
      var hrs = Array.prototype.filter.call(content.children, function (n) { return n.tagName === 'HR'; });
      var n = items.length;
      items.forEach(function (it, i) {
        var el = document.createElement('div');
        el.className = 'mc-inline-product';
        var anchor = null;
        if (hrs.length >= n) {
          var step = Math.floor(hrs.length / (n + 1)) || 1;
          anchor = hrs[Math.min((i + 1) * step, hrs.length - 1)];
        }
        if (anchor && anchor.parentNode) {
          anchor.parentNode.insertBefore(el, anchor.nextSibling);
        } else {
          content.appendChild(el);
        }
        fill(el, it.handle, it.title, it.blurb);
      });
    });
  }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
